module.exports = __webpack_public_path__ + "static/media/28.e2067381.jpeg";